import { Link } from "react-router-dom";
import images from "../../assets/images/assets";

const InstaLink = () => {
  const instaUrl = "https://www.instagram.com/itsallaboutcards/?hl=en";
  const handleClick = () => {
    window.open(instaUrl, "_blank");
  };

  return (
    <Link to={instaUrl} target="_blank" onClick={handleClick}>
      <div className="centered-row gap-2 items-center  ">
        <img src={images.insta} alt="instagram logo" className="w-7 lg:w-10" />
        <span>
          <a
            href="#"
            className="font-semibold text-prime-red montserrat lg:text-xl 2xl:text-2xl"
          >
            itsallaboutcards
          </a>
        </span>
      </div>
    </Link>
  );
};

export default InstaLink;
